    export class MediaTracking {
        audios: NodeListOf<HTMLElement>;
        videos: NodeListOf<HTMLElement>;
        constructor() {
            this.audios = document.querySelectorAll('[data-audio-tracking]');
            this.videos = document.querySelectorAll('[data-video-tracking]');
            this.init();
        }

        init() {
            this.addEventListenersAudio()
            this.addEventListenersVideo()
        }

        addEventListenersAudio() {
            this.audios.forEach((tracker) => {
                const audio: HTMLMediaElement = tracker.querySelector('[data-audioplayer-audio]'),
                    key: string = tracker.dataset.audioTracking;

                audio.addEventListener('play', () => {
                    const xhr = new XMLHttpRequest();
                    const url = window.location.href + '/api/mediatracking/create/';
                    xhr.open("POST", url, true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    xhr.send('identifier=' + key);
                });
            });
        }

        addEventListenersVideo() {
                this.videos.forEach((tracker) => {

                const video = tracker.querySelector<HTMLVideoElement>('video'),
                key: string = tracker.dataset.videoTracking;

                video.addEventListener('play', () => {
                    const xhr = new XMLHttpRequest();
                    const url = window.location.href + '/api/mediatracking/create/';
                    xhr.open("POST", url, true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    xhr.send('identifier=' + key);
                });
            });
        }


    }
    document.addEventListener("DOMContentLoaded", function() {
        new MediaTracking();
    });
